import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./CheckoutSuccess.css";

function CheckoutPending() {
  const navigate = useNavigate();
  const location = useLocation();

  const { pedidoId, noPo } = useMemo(() => {
    const st = location.state || {};
    return {
      pedidoId: st.pedido_id || null,
      noPo: st.no_po || null,
    };
  }, [location.state]);

  useEffect(() => {
    try {
      localStorage.removeItem("cart");
      sessionStorage.removeItem("grupo_reserva");
    } catch {}
  }, []);

  return (
    <div className="checkout-success-wrapper">
      <div className="checkout-success-card">
        <div className="checkout-success-icon">✔</div>

        {/* Decia "Order Completed!" y el renglon siguiente decia que el
            pedido estaba pendiente. El cliente que lee el titulo y cierra
            se queda creyendo que ya esta comprado. */}
        <h1 className="checkout-success-title">Order received</h1>

        {(pedidoId || noPo) && (
          <p className="checkout-success-text" style={{ marginTop: 10 }}>
            {pedidoId && (
              <>
                Your order <strong>#{pedidoId}</strong> has been created.
              </>
            )}
            {pedidoId && noPo ? " " : ""}
            {noPo && (
              <>
                PO number: <strong>{noPo}</strong>.
              </>
            )}
          </p>
        )}

        <p className="checkout-success-text">
          We have received your order and it&apos;s currently{" "}
          <strong>pending</strong>. One of our staff members will contact you to
          choose the best payment method. Thank you for your order!
        </p>

        <div className="checkout-success-actions">
          <button
            className="checkout-success-btn outline"
            onClick={() => navigate("/store/login")}
          >
            View my orders
          </button>

          <button
            className="checkout-success-btn primary"
            onClick={() => navigate("/")}
          >
            Continue shopping
          </button>
        </div>
      </div>
    </div>
  );
}

export default CheckoutPending;
